export default __webpack_public_path__ + "static/media/InfoScore.62dfff28.png";